import React from "react";
import { useLocation } from "react-router-dom";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
} from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

import { IUserNotificationWithDetails } from "@modules/notifications/model/INotifications";
import { useFlags } from "flagsmith/react";
import { NOTIFICATION_FLAG } from "@utils/featureFlags";
import RichTextDisplay from "@components/RichTextDisplay/RichTextDisplay";

interface Props {
  open: boolean;
  notificationUser: IUserNotificationWithDetails | null;
  hasNext: boolean;
  onClose: () => void;
  onUnread: () => void;
  onNext: () => void;
}

const NotificationPortalModal: React.FC<Props> = ({
  open,
  notificationUser,
  hasNext,
  onClose,
  onUnread,
  onNext,
}) => {
  const flag = useFlags([NOTIFICATION_FLAG]);
  const { pathname = "" } = useLocation();
  const isSidebarAdmin = pathname.includes("/admin");

  if (
    !notificationUser ||
    isSidebarAdmin ||
    !flag.admin_sidebar_notification.enabled
  )
    return null;

  const notification = notificationUser.notification;

  const isRead = Boolean(notificationUser.readAt);
  const showPrimaryButon = hasNext || !isRead;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      {/* HEADER COM ID NO CANTO SUPERIOR DIREITO */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 1,
          pt: 1,
        }}
      >
        <Box />
        <Typography sx={{ fontSize: 12, color: "#888" }}>
          #{notification.refId}
        </Typography>
      </Box>

      {/* ÍCONE CENTRAL */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 1,
        }}
      >
        <Box
          sx={{
            width: 60,
            height: 60,
            bgcolor: "#FFF2F2",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <NotificationsActiveIcon sx={{ fontSize: 32, color: "#E53935" }} />
        </Box>
      </Box>

      {/* TÍTULO */}
      <DialogTitle
        sx={{
          textAlign: "center",
          fontSize: 22,
          fontWeight: 700,
          color: "#222",
        }}
      >
        {notification.title}
      </DialogTitle>

      {/* TEXTO */}
      <DialogContent>
        <Typography
          sx={{
            textAlign: "center",
            color: "#444",
            fontSize: 15,
            lineHeight: 1.6,
            mb: 3,
          }}
        >
          <RichTextDisplay content={notification.content} />
        </Typography>
      </DialogContent>

      {/* BOTÕES */}
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          mb: 2,
        }}
      >
        <Button
          variant="contained"
          onClick={showPrimaryButon ? onNext : onClose}
          sx={{
            bgcolor: "#E53935",
            fontWeight: 600,
            px: 4,
            "&:hover": { bgcolor: "#C62828" },
          }}
        >
          {showPrimaryButon
            ? hasNext
              ? "Próxima"
              : "Marcar como lida"
            : "Fechar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationPortalModal;
